export const STATE_TYPES = [
  { name: 'todo', text: 'делать', active: true },
  { name: 'process', text: 'в работе', active: true },
  { name: 'done', text: 'готово', active: false },
  { name: 'accept', text: 'принято', active: false },
  { name: 'fix', text: 'исправить', active: true },
  { name: 'pause', text: 'пока стоп', active: true },
  { name: 'delete', text: 'выкинуто', active: false },
  { name: 'notrequired', text: 'не требуется', active: false },
] as const;

export type StateName = (typeof STATE_TYPES)[number]['name'] | 'empty';

export const ACTIVE_STATE_VALUES = STATE_TYPES.filter((state) => state.active).map(
  (state) => state.text,
);
export const CLOSED_STATE_VALUES = STATE_TYPES.filter((state) => !state.active).map(
  (state) => state.text,
);

export function stateName(value: string | null | undefined): StateName {
  return STATE_TYPES.find((state) => state.text === value)?.name ?? 'empty';
}

export function formatHours(value: number | null | undefined): string {
  if (value == null) return '—';
  return String(Math.round(value * 100) / 100).replace('.', ',');
}

export function formatDate(value: string | null | undefined, withTime = false): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.valueOf())) return '—';
  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
  }).format(date);
}

export function framesSummary(frames: number, fps = 25): string {
  if (!frames) return '—';
  const wholeSeconds = Math.floor(frames / fps);
  const hours = Math.floor(wholeSeconds / 3600);
  const minutes = Math.floor((wholeSeconds % 3600) / 60);
  const seconds = wholeSeconds % 60;
  const remainingFrames = frames % fps;
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${pad(hours)}.${pad(minutes)}.${pad(seconds)}:${remainingFrames} (${new Intl.NumberFormat('ru-RU').format(frames)})`;
}

export function toDateTimeLocal(value: string | null | undefined): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.valueOf())) return '';
  const shifted = new Date(date.valueOf() - date.getTimezoneOffset() * 60_000);
  return shifted.toISOString().slice(0, 16);
}

export function fromDateTimeLocal(value: string): string | null {
  return value ? new Date(value).toISOString() : null;
}

export function toDateInput(value: string | null | undefined): string {
  return toDateTimeLocal(value).slice(0, 10);
}

export function fromDateInput(value: string): string | null {
  return value ? new Date(`${value}T00:00:00`).toISOString() : null;
}
